"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PuzzleHistory = void 0;
class PuzzleHistory {
    constructor(puzzle) {
        this.history = [];
        this.history.push(puzzle);
    }
    get size() {
        return this.history.length;
    }
    append(puzzle) {
        if (puzzle.candidate || puzzle.latchIsMoved) {
            return;
        }
        const last = this.history[this.history.length - 1];
        if (last.moveCount === puzzle.moveCount) {
            return;
        }
        this.history.push(puzzle);
    }
    rewind() {
        if (this.history.length > 1) {
            this.history.pop();
            return this.history[this.history.length - 1];
        }
    }
}
exports.PuzzleHistory = PuzzleHistory;
